import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ActionButton = styled(Button)({
  minWidth: '60px',
})

export const ActionContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '32px',
})

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
})
